import { combineReducers } from "redux";

import { bookingEnquiryDetails } from "./reducer.bookingEnquiry"
const bookingEnquiryReducers = combineReducers({
  bookingEnquiryDetails
})
export default bookingEnquiryReducers;
